<form [formGroup]="form">
  <div class="request-exchange-search-container">
    <div class="request-exchange-search-input-container">
      <div class="input-group-container">
        <h5 class="search-by">Search by CUSIP</h5>

        <div class="input-group-cusip">
          <ng-container
            *ngIf="
              !form.controls.CUSIP.pristine &&
              form.controls.CUSIP.value !== '' &&
              !isSearchBtnEnable &&
              !isCusipFieldFocused
            "
          >
            <i
              class="fa fa-exclamation-circle input-group-container-addon-cusip input-group-container-addon--disabled"
            ></i>
          </ng-container>
          <ng-container *ngIf="form.controls.CUSIP.value !== '' && !form.controls.CUSIP.pristine">
            <div (click)="cancelCusipInput()">
              <i
                class="fa fa-times-circle input-group-cusip-cancel-button input-group-container-addon--disabled"
                aria-hidden="true"
              ></i>
            </div>
          </ng-container>
          <input
            class="request-exchange-search__input request-exchange-search__input--full-width"
            class="uppercase-text input-box-size"
            id="inputCusip"
            #inputCusip
            formControlName="CUSIP"
            type="text"
            (keypress)="onEnterHit($event)"
            (keyup)="toggleCusipDealerInputs('cusipField')"
            (blur)="resetCusipDealerInputs('cusipField')"
            (focus)="onCusipFocus()"
            placeholder="Enter CUSIP (ex. 3136AFKB9)"
            maxlength="9"
            [(ngModel)]="usrCUSIPInput"
            autocomplete="off"
            spellcheck="false"
          />
        </div>

        <ng-container
          *ngIf="
            form.controls.CUSIP.value !== '' &&
            !isSearchBtnEnable &&
            !isCusipFieldFocused &&
            !form.controls.CUSIP.pristine
          "
        >
          <span class="enter-valid-cusip-lable">Please enter a valid CUSIP Number</span>
        </ng-container>

        <div id="header">
          <p id="test">OR</p>
        </div>

        <div class="search-by-dealNbr">
          <h5 class="search-by">Search by Deal Number</h5>
          <div class="input-group-container">
            <ng-container
              *ngIf="form.controls.dealNbr.value !== '' && !form.controls.dealNbr.pristine"
            >
              <i
                (click)="showError.dealNbr = false; resetInput()"
                class="fa fa-times-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon--float--right tooltip-error"
              ></i>
            </ng-container>
            <input
              class="request-exchange-search__input request-exchange-search__input--full-width uppercase-text input-box-size"
              id="inputDealNbr"
              #inputDealNbr
              formControlName="dealNbr"
              type="text"
              (keypress)="onEnterHit($event)"
              (keyup)="toggleCusipDealerInputs('dealNumberField')"
              (blur)="resetCusipDealerInputs('dealNumberField')"
              (focus)="onDealerFocus()"
              placeholder="Enter Deal (ex. 2016-001) "
              name="dealOrCusip"
              maxlength="9"
              [(ngModel)]="usrInput"
              autocomplete="off"
              spellcheck="false"
            />
          </div>
          <ng-container
            *ngIf="
              form.controls.dealNbr.value !== '' &&
              !isSearchBtnEnable &&
              !isDealNbrFieldFocused &&
              !form.controls.dealNbr.pristine
            "
          >
            <span class="danger input-warn fa fa-exclamation-circle fa-2x"></span>
            <div class="danger">Please enter a valid Deal Number</div>
          </ng-container>
        </div>

        <div>
          <button
            (click)="onDealSearch()"
            [disabled]="!isSearchBtnEnable || !isTraderSel"
            class="button fm-primary-button request-exchange-search__button request-exchange-search__button--full-width"
            [class.formInvalid]="form.get('dealNbr').hasError('sfRemicError')"
            [class.formInvalid]="form.get('CUSIP').hasError('sfRemicCUSIPError')"
            [class.formInvalid]="form.get('dealNbr').hasError('smbsError')"
            [class.formInvalid]="form.get('dealNbr').hasError('mfRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('bmRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('bmRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('gtRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('wlRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('gnRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('stRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('plRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('callableRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('ddRemicError')"
            [class.formInvalid]="form.get('dealNbr').hasError('redeemRemicError')"
            type="button"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
